import React, { useEffect, useState } from "react";
import { Form, Col, Row } from "react-bootstrap";
import { useTranslation } from 'react-i18next';

const VideoPlatformPreview = ({ videoPlatform, videoUrl }) => {
	const { t } = useTranslation();
	const [vimeoPreviewImage, setVimeoPreviewImage] = useState(null);

	useEffect(() => {
		if (!videoPlatform || !videoUrl) return;

		if (videoPlatform === 'vimeo') {
			if (videoUrl.length > 3) {
				fetch(`https://vimeo.com/api/v2/video/${videoUrl}.json`, {
					method: "get"
				})
					.then(response => {
						if (response.status === 404) {
							throw 404; // eslint-disable-line
						}
						return response.json();
					})
					.then(response => {
						if (response.length) {
							const { thumbnail_medium } = response[0];
							setVimeoPreviewImage(thumbnail_medium);
						}
					})
					.catch(err => {
						if (err === 404) {
							setVimeoPreviewImage('https://img.youtube.com/vi/1234/mqdefault.jpg');
							return;
						}
						setVimeoPreviewImage(null);
					});
			} else {
				setVimeoPreviewImage('https://img.youtube.com/vi/1234/mqdefault.jpg');
			}
		}
	}, [videoPlatform, videoUrl]);

	return (
		<>
			{(videoPlatform === 'youtube' || videoPlatform ==='vimeo') &&
				<div key={videoPlatform}>
					<Col style={{ marginTop: '-10px', marginBottom: 20 }} sm={{ offset: 3, span: 9 }}>
						<p className="text-muted">
							{videoPlatform === 'youtube' && <> {t('partner.video_preview_youtube_1')} https://www.youtube.com/watch?v=<strong>dQw4w9WgXcQ</strong>. {t('partner.video_preview_2')}</>}
							{videoPlatform === 'vimeo' && <> {t('partner.video_preview_vimeo_1')} https://vimeo.com/<strong>235352744</strong>. {t('partner.video_preview_2')}</>}
						</p>
					</Col>
					{videoUrl &&
						<Form.Group as={Row}>
							<Form.Label column sm={3}>
								{t('partner.preview_image')}
							</Form.Label>
							<Col sm={9}>
								{
									videoPlatform === 'youtube' &&
									<img
										width="200px"
										alt="Video thumbnail preview"
										title="Video thumbnail preview"
										src={`https://img.youtube.com/vi/${videoUrl}/mqdefault.jpg`}
									/>
								}
								{
									videoPlatform === 'vimeo' && vimeoPreviewImage &&
									<img
										width="200px"
										alt="Video thumbnail preview"
										title="Video thumbnail preview"
										src={`${vimeoPreviewImage}`}
									/>
								}

							</Col>
						</Form.Group>
					}
				</div>}
		</>
	)
};

export default VideoPlatformPreview;
